import { currentAnchor, rangeFor, shiftAnchor } from "./historyRange.js";

// Report periods: historyRange's month / quarter / year, plus half-year (H1 Jan–Jun,
// H2 Jul–Dec). Kept separate so historyRange's own callers (attendance history and
// grid) are unaffected by the extra period.

export type ReportPeriod = "month" | "quarter" | "half" | "year";

export const REPORT_PERIOD_OPTIONS: { value: ReportPeriod; label: string }[] = [
  { value: "month", label: "Month" },
  { value: "quarter", label: "Quarter" },
  { value: "half", label: "Half-year" },
  { value: "year", label: "Year" },
];

const pad = (n: number) => String(n).padStart(2, "0");

export function reportAnchor(period: ReportPeriod): string {
  if (period !== "half") return currentAnchor(period);
  const month = currentAnchor("month");
  const startMonth = Number(month.slice(5, 7)) <= 6 ? 1 : 7;
  return `${month.slice(0, 4)}-${pad(startMonth)}-01`;
}

export function shiftReportAnchor(period: ReportPeriod, anchor: string, delta: number): string {
  if (period !== "half") return shiftAnchor(period, anchor, delta);
  const d = new Date(`${anchor}T00:00:00Z`);
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + delta * 6, 1)).toISOString().slice(0, 10);
}

export function reportRange(period: ReportPeriod, anchor: string): { from: string; to: string; label: string } {
  if (period !== "half") return rangeFor(period, anchor);
  const d = new Date(`${anchor}T00:00:00Z`);
  const year = d.getUTCFullYear();
  const first = d.getUTCMonth() < 6;
  const to = new Date(Date.UTC(year, first ? 6 : 12, 0)).toISOString().slice(0, 10);
  return { from: anchor, to, label: `${first ? "H1" : "H2"} ${year} (${first ? "Jan–Jun" : "Jul–Dec"})` };
}
